import { jsxs, jsx } from 'react/jsx-runtime';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';
import { useApi, alertApiRef } from '@backstage/core-plugin-api';
import { assertError } from '@backstage/errors';
import { catalogTranslationRef } from '../../alpha/translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

function DeleteEntityDialog(props) {
  const { open, onClose, onConfirm, entity } = props;
  const [busy, setBusy] = useState(false);
  const catalogApi = useApi(catalogApiRef);
  const alertApi = useApi(alertApiRef);
  const { t } = useTranslationRef(catalogTranslationRef);
  const onDelete = async () => {
    setBusy(true);
    try {
      const uid = entity.metadata.uid;
      await catalogApi.removeEntityByUid(uid);
      onConfirm();
    } catch (err) {
      assertError(err);
      alertApi.post({ message: err.message });
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ jsxs(Dialog, { open, onClose, children: [
    /* @__PURE__ */ jsx(DialogTitle, { id: "responsive-dialog-title", children: t("deleteEntity.dialogTitle") }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "contained",
          color: "secondary",
          disabled: busy,
          onClick: onDelete,
          children: t("deleteEntity.deleteButtonTitle")
        }
      ),
      /* @__PURE__ */ jsx(Button, { onClick: onClose, color: "primary", children: t("deleteEntity.cancelButtonTitle") })
    ] })
  ] });
}

export { DeleteEntityDialog };
//# sourceMappingURL=DeleteEntityDialog.esm.js.map
